import { useRef, useState } from "react";
import { Button, useTheme } from "@mui/material";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || '/api';

export default function PlayersUpload() {
  const fileInputRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const token = window.localStorage.getItem("loggedBLUser");
  const theme = useTheme();

  const handleFileChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedFiles.length === 0) return;
    // Read all files as text
    const readFiles = selectedFiles.map(file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          resolve({
            node: file.name.replace(/\.csv$/i, ""),
            content: event.target.result
          });
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    });
    try {
      const filesArr = await Promise.all(readFiles);
      await axios.post(
        `${apiUrl}/players/upload`,
        { files: filesArr },
        { headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        } }
      );
      setSelectedFiles([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: theme.palette.text.primary }}>Players in City CSV Upload</h2>
      <p style={{ color: theme.palette.text.primary, marginBottom: 16 }}>
        Upload one or more CSV files, each containing information about the players currently present in a city. You can select and upload multiple files at once. <br />
        <b>Each file should correspond to a specific city, and must be named with the node number of the city, e.g. <code>123.csv</code> for node 123.</b>
      </p>
      <form onSubmit={handleSubmit}>
        <input
          id="csv-upload"
          type="file"
          accept=".csv"
          multiple
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        <label
          htmlFor="csv-upload"
          style={{
            background: '#eee',
            color: '#222',
            border: '1px solid #ccc',
            borderRadius: 4,
            padding: '8px 20px',
            fontSize: 16,
            cursor: 'pointer',
            fontWeight: 500,
            marginRight: 16,
            display: 'inline-block',
          }}
        >
          Choose Files
        </label>
        <span style={{ color: theme.palette.text.primary, fontSize: 16 }}>
          {selectedFiles.length === 0
            ? 'No files selected'
            : selectedFiles.length === 1
              ? selectedFiles[0].name
              : `${selectedFiles.length} files selected`}
        </span>
        <br /><br />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ fontSize: 18, padding: '12px 12px', marginTop: 8 }}
          disabled={selectedFiles.length === 0}
        >
          Upload Files
        </Button>
      </form>
    </div>
  );
}
